import { isValid, setHours } from "date-fns";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { Nullable, Optional } from "./extendedTypes";

export const DATE_ISO = "dd MMM yyyy";
export const DATE_MONTH_YEAR = "dd MMMM yyyy";
export const DATE_FORMAT = "dd/MM/yyyy";
export const DATEO_MONTH_YEAR = "do  MMMM yyyy";
export const DATE_ISO_FORMAT = "yyyy-MM-dd";

export const toDate = (s: string): Date => parseISO(s);
export const toISODate = (d: Date): string => format(d, DATE_ISO_FORMAT);
export const toDateFormat = (d: Date): string => format(d, DATE_MONTH_YEAR);
export const toDateOFormat = (d: Date): string => format(d, DATEO_MONTH_YEAR);
export const toNullableDate = (s: Optional<string>): Nullable<Date> =>
  s ? toDate(s) : null;

export const toNullableISODate = (d: Nullable<Date>): Nullable<string> =>
  d === null ? null : format(d, DATE_ISO);
export const parseDate = (val: string): Date => {
  const date = parseISO(val);
  if (date instanceof Date && isValid(date)) {
    return setHours(date, 12);
  }
  throw new Error(val);
};

export type DateRange = [Nullable<Date>, Nullable<Date>];
